import { createStore } from 'vuex';

export default createStore({
  state: {
    value: '',
    token:'',
    url:'',
    Current:'',
    HomeData:'',
    UserInfo:'',
    OperatePassState:false,
    companyId:''
  },
  mutations: {
    setcompanyId (state, payload) {
      state.companyId = payload
    },   
    setValue (state, payload) {
      state.value = payload
    },
    setToken (state, payload) {
      state.token = payload
    },
    setUrl (state, payload) {
      state.url = payload
    },
    setUserName (state, payload) {
      state.UserName = payload
    },
    setAuthority(state, payload){
      state.Authority = payload
    },
    setCurrent(state, payload){
      state.Current = payload
    },
    setHomeData(state, payload){
      state.HomeData = payload
    },
    setUserInfo (state, payload) {
      state.UserInfo = payload
    },
    setRule (state, payload) {
      state.Rule = payload
    },
    setOperatePassState (state, payload) {
      state.OperatePassState = payload
    }
  },
  actions: {
    updateValue ({ commit }, payload) {
      commit('setValue', payload)
    }
  },
  getters: {
   
  },
  modules: {
  },
});
